//
//
//
import drApplyBase from '../../applyManage/drApplyBase';
export default {
  name: 'orderManage',
  components: {
    drApplyBase: drApplyBase
  }
};